import React, { useRef } from "react";
import {useSelector} from "react-redux";
import {useStyles} from "./ReportQueue.styles";
import {Box, Typography, Divider, Button} from "@material-ui/core";
import ReportQueueAdminManagement from "../../../components/ReportQueueAdminManagement/ReportQueueAdminManagement";
import { useState } from "react";


const ReportQueueAdminPage = () => {
  const classes = useStyles();
  const isAdmin = useSelector(state => state?.user?.isAdmin);
  const reportQueueRef = useRef();
  const [isPaused, setIsPaused] = useState(false);

  const handlePauseStatus = (initialState) => {
    setIsPaused(initialState);
  };

  if (!isAdmin) return <></>;

  const handlePauseClick = () => {
    if (reportQueueRef.current) {
      reportQueueRef.current.handleUpdate(!isPaused);
    }
  };


  return(
    <div className={classes.root}>
      <Box display="flex" justifyContent="space-between" alignItems="center" className={classes.header}>
        <Typography className={classes.title} variant="h4">Report Queue Administration</Typography>
        <Button variant="contained" color="secondary" onClick={handlePauseClick}>
          {isPaused ? "Unpause Queues" : "Pause Queues"}
        </Button>
      </Box>
      <Divider className={classes.titleDivider}/>
      <Box display="flex" justifyContent="center" alignItems="center">       
          <ReportQueueAdminManagement 
            ref={reportQueueRef}
            updatePauseStatus={handlePauseStatus}
          />      
      </Box>
    </div>
  );
}

export default ReportQueueAdminPage;